import RegistrationStart from "../registration/RegistrationStart";

import {
  Box,
  Container,
  Typography,
  Link,
  Alert
} from '@mui/material';
import UserAvatarMenu from '../../components/auth/UserAvatarMenu';
import { useAuth } from '../../components/auth/AuthContext';

export default function CityWideHousingSolutions() {
  const { showAuthDialog, currentUser } = useAuth();

  return (
    <Box 
      sx={{ 
        minHeight: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center'
      }}
    >
      <Container maxWidth="md">
        <UserAvatarMenu />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'space-between',
            minHeight: '100vh',
            py: { xs: 8, md: 16 },
            px: { xs: 2, md: 8 },
            textAlign: { xs: 'center', sm: 'left' }
          }}
        >
          <Typography 
            variant="h2" 
            component="h1" 
            fontWeight="bold" 
            sx={{ 
              mb: 4, 
              fontSize: { xs: '2rem', md: '3rem', lg: '4rem' },
              lineHeight: 1.2 
            }}
          >
            CityWide Housing Solutions
          </Typography>
          
          <Box>
            <Alert severity="warning" sx={{ mb: 4}} icon={false}>
              <p>Additional hotels are being contracted to meet the needs of every attendee at HOSA ILC. An additional block of hotels will released on April 22nd. Shuttle service will run the entirety of the conference between the convention center and every hotel more than 0.5 miles from the conference.</p>
<p>If you do not see a hotel that meets your needs, you will see a placeholder hotel as an option. Please add yourself to this placeholder AND book all the rooms that you need for your stay.</p>
<p>By adding your order to the placeholder hotel, you will be added to our list of those needed rooms and processed in the order received. You will get regular updates on the progress. We anticipate having everyone booked into a hotel no later than May 7.</p>
<p>We want to be clear. There will be plenty of hotel rooms for everyone attending ILC.</p>
<p>We do still have King rooms at some excellent hotel options downtown. If you have the ability to arrange your booking in all King rooms, please do so.</p>
            </Alert>
          </Box>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, width: '100%', maxWidth: 'md' }}>
            <RegistrationStart />
          </Box>
          
          <Box sx={{ mt: 4 }}>
            <Typography variant="h6" color="text.secondary">
              Don't have a passcode?{' '}
              <Link href="/faq" underline="hover" fontWeight="medium">
                Check our FAQ
              </Link>
              {' '}for help getting started.
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}